import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, model, output } from '@angular/core';

export const DS_CARD_HEADER_VARIANT_ARRAY = ['surface-lowest', 'surface-low', 'surface-high', 'surface-highest'] as const;
export type DsCardHeaderVariant = (typeof DS_CARD_HEADER_VARIANT_ARRAY)[number];

@Component({
    selector: 'ds-card-header',
    template: ` <ng-content select="[slot=start]" />
        <div class="ds-card-header-text" (click)="onTextClick()">
            <div class="ds-card-header-title-wrapper">
                @if (title()) {
                    <span class="ds-card-header-title" [class.ds-card-header-title-expand]="!subtitle()">{{ title() }}</span>
                }
                <ng-content select="[slot=title]" />
            </div>
            @if (subtitle()) {
                <span class="ds-card-header-subtitle">{{ subtitle() }}</span>
            }
        </div>
        <div class="ds-card-header-slot-container">
            <ng-content select="[slot=end]" />
        </div>`,
    host: {
        'class': 'ds-card-header',
        '[class]': `hostClass()`,
        '[class.ds-card-header-inverse]': 'inverse()',
    },
    styleUrl: 'card-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [],
})
export class DsCardHeader {
    public readonly title = input<string | undefined>('');
    public readonly subtitle = input<string | undefined>('');

    public readonly variant = model<DsCardHeaderVariant>('surface-lowest');
    public readonly inverse = model<boolean>(false);
    protected readonly hostClass = computed(() => `ds-card-header-${this.variant()}`);

    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    public readonly headerClick = output<void>();

    onTextClick() {
        this.headerClick.emit();
    }
}
